import {
  Button,
  Center,
  ColorInput,
  Flex,
  Modal,
  NumberInput,
  Radio,
  Select,
  Text
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";

import { useCallback, useEffect, useRef, useState } from "react";
//import { useRecoilState } from "recoil";
//import { userState } from "pages/Login/atom/userState";
import {
  getDevice,
  getDeviceList,
} from "pages/Admin/Device/apis/adminDeviceApis";
import { getLibraryList } from "pages/Admin/Library/apis/adminLibraryApis";
import React from "react";
import { getObj, updateObj } from "../apis/adminSiteEditApis";
import CopyDeviceObject from "./CopyDeviceObject";
import DraggableArea from "./DraggableArea";
import ObjectAddEditForm from "./ObjectAddEditForm";
import ObjectItem from "./ObjectItem";
import ObjectManagement from "./ObjectManagement";
import ThresholdForm from "./ThresholdForm";

const SelectComponents = {
  FieldsType: (props) => { /* ... */ },
  AltText: (props) => { /* ... */ },
  Library: (props) => { /* ... */ },
  Device: (props) => { /* ... */ },
  FontSize: (props) => { /* ... */ },
  Color: (props) => { /* ... */ }
};

export const FIELDS = [ /* ... */ ];

function SiteEditAddForm(props) {    // 현장(오브젝트) 편집 창
  const {
    defaultObjectState = {},
    defaultObjectList,
    defaultImgyeList,
    fieldList,
  } = props;

//  const [user, setUser] = useRecoilState(userState);
 // const groupId = user.fn_group_id;

  const {
    group_id = defaultObjectState.group_id ?? "",
    field_id = defaultObjectState.value ?? "",
    object_id = defaultObjectState.object_id ?? "",
  } = defaultObjectState;

  const onConfirmExecutedRef = useRef(false);

  const [objectList, setObjectList] = useState(defaultObjectList);
  const [deleteObjectList, setDeleteObjectList] = useState([]);
  const [deleteImgyeList, setDeleteImgyeList] = useState([]);   

  const [imgyeList, setImgyeList] = useState(defaultImgyeList);
  const [imgyeState, setImgyeState] = useState();

  useEffect(() => {
    setObjectList(defaultObjectList);
    setImgyeList(defaultImgyeList);
  }, [defaultObjectList]);

  const [copyDeviceObjectOpened, copyDeviceObjectControl] =
    useDisclosure(false);
  const copyDeviceObjectOpen = () => copyDeviceObjectControl.open();
  const copyDeviceObjectClose = () => {
    copyDeviceObjectControl.close();
  };

  const [objectManagementOpened, objectManagementControl] =
    useDisclosure(false);
  const handleObjectManagementOpen = () => objectManagementControl.open();
  const handleObjectManagementClose = () => {
    setSelectedRecords([]);
    setSelectedImgye([]);
    objectManagementControl.close();
  };

  const [objectAddEditModalOpened, objectAddEditModalControl] =
    useDisclosure(false);
  const [objectDefaultValue, setObjectDefaultValue] = useState();
  const [imgyeDefaultValue, setImgyeDefaultValue] = useState(imgyeState);

  const handleObjectAddEditModalOpen = useCallback((id) => {
    if (id) {
      setObjectDefaultValue(objectList.find((object) => object.obj_id === id));
    } else {
      setObjectDefaultValue();
    }
    objectAddEditModalControl.open();
  }, [objectList]);

  const handleObjectAddEditModalClose = () => {   // 오브젝트 생성/수정
    objectAddEditModalControl.close();
    setImgyeState();
  };

  const [handleThresholdOpened, handleThresholdControl] = useDisclosure(false);
  const [selectedRecords, setSelectedRecords] = useState([]);
  const [selectedImgye, setSelectedImgye] = useState([]);

  const handleThresholdOpen = (id) => {
    if (imgyeState) {
      setImgyeDefaultValue(imgyeState);
    } else {
      setImgyeDefaultValue(imgyeList?.find((imgye) => imgye.obj_id === id));
    }
    handleThresholdControl.open();
  };

  const handleThresholdClose = () => {
    handleThresholdControl.close();
  };

  const insertObject = async () => {
    try {
      let successMessage = "";
      if (!object_id) {
        successMessage = "저장 되었습니다.";
      } else {
        const newObjectList = [
          ...objectList,
          ...deleteObjectList.map((item) => ({ ...item, del_yn: "Y" })),
        ];
        const updatedImgyeList = imgyeList.map((imgye) =>
          imgye.imgye_id === imgye.obj_id ? { ...imgye, imgye_id: null } : imgye      
        );
        const newImgyeList = [    
          ...updatedImgyeList,
          ...deleteImgyeList.map((item) => ({ ...item, del_yn: "Y" })),
        ];

        await updateObj(object_id, newObjectList, newImgyeList,"siteEdit");  
        successMessage = "업데이트 되었습니다.";
      }

      const res = await getObj(
        defaultObjectState?.value,
        defaultObjectState?.object_id
      );

      setObjectList(
        res.view.sort((a, b) => {
          if (a.obj_seq !== b.obj_seq) {
            return a.obj_seq - b.obj_seq; // obj_seq 오름차순 정렬
          } else {
            return a.obj_id - b.obj_id; // obj_id 오름차순 정렬 (obj_seq가 같을 경우)
          }
        })
      );
      setImgyeList(res.imgye);
      setDeleteObjectList([]);   
      setDeleteImgyeList([]);   
      alert(successMessage); 
    } catch (error) {
      console.error('Error inserting object:', error);
      alert('오류가 발생했습니다. 다시 시도해주세요.');
    }
  };

  const fieldsTypeOptions = [
    { value: "1", label: "관제" },
    { value: "2", label: "CCTV" },
    { value: "3", label: "날씨" },
    { value: "4", label: "통신" },   
  ];

  const radioAltTextOptions = [
    { value: "Y", label: "Yes" },
    { value: "N", label: "No" },
  ];

  const [selectedFieldsType, setSelectedFieldsType] = useState();
  const [selectedAltTextOption, setSelectedAltTextOption] = useState();
  const [selectedControlType, setSelectedControlType] = useState();

  const [libraryList, setLibraryList] = useState([]);
  const [deviceList, setDeviceList] = useState([]);

  useEffect(() => {
    if(group_id === null || group_id === "" || !group_id ) return;
    getLibraryList(100, 1,group_id ).then((res) => {
      const mappedData = res.map((item) => ({
        value: item.download_link,
        label: item.title,
      }));
      setLibraryList(mappedData);
    });
  }, [group_id]);

  useEffect(() => {
    getDeviceList(100, 1, group_id).then((res) => {
      const mappedData = res.map((item) => ({
        value: item.bsd_id,
        label: item.bsd_nm,
      }));
      setDeviceList(mappedData);
    });
  }, [group_id]);

  const SelectFieldsType = (props) => {
    const { field, name, defaultValue } = props;
    setSelectedFieldsType(field.value);
    return (
      <Select
        label={name}
        data={fieldsTypeOptions}
        value={field.value}
        defaultValue={defaultValue}
        {...field}
      />
    );
  };

  const RadioAltText = (props) => {
    const { field, name, defaultValue } = props;
    if (name === "대체텍스트 여부") setSelectedAltTextOption(field.value);
    if (name === "제어 여부") setSelectedControlType(field.value);

    return (
      <Radio.Group label={name} defaultValue={defaultValue} {...field}>
        <Flex gap="md">
          {radioAltTextOptions.map((option) => (
            <>
              <Radio
                key={option.value}
                value={option.value}
                label={option.label}
              />
            </>
          ))}
        </Flex>
      </Radio.Group>
    );
  };

  const SelectLibrary = (props) => {
    const { field, name } = props;
    return (
      <Select
        clearable
        label={name}
        data={libraryList}
        value={field.value}
        {...field}
      />
    );
  };

  const [bsdId, setBsdId] = useState("");

  const SelectDevice = (props) => {
    const { field, name } = props;
    if (name === "장치") setBsdId(field.value);
    return (
      <Select
        clearable
        label={name}
        data={deviceList}
        value={field.value}
        {...field}
      />
    );
  };
  const [deviceStatusList, setDeviceStatusList] = useState([]);
  const [deviceControlList, setDeviceControlList] = useState([]);

  useEffect(() => {
    getDevice(bsdId ?? 0).then((res) => {
      setDeviceStatusList(
        res.sttus
          .filter((status) => status.chnnl_prcsdg === "1")
          .map((status) => ({
            label: status.chnnl_nm,
            value: status.bsd_sttus_id,
          }))
      );
      setDeviceControlList(
        res.ctrl
          .filter((control) => control.chnnl_prcsdg === "1")
          .map((control) => ({
            label: control.chnnl_nm,
            value: control.bsd_ctrl_id,
          }))
      );
    });
  }, [bsdId]);

  const SelectDeviceStatus = (props) => {
    const { field, name } = props;
    return (
      <Select
        clearable
        label={name}
        data={deviceStatusList}
        value={field.value}
        {...field}
      />
    );
  };

  const SelectDeviceControl = (props) => {
    const { field, name } = props;
    return (
      <Select
        clearable
        label={name}
        data={deviceControlList}
        value={field.value}
        {...field}
      />
    );
  };

  const SelectFontSize = (props) => {
    const { field, name, defaultValue, disabled } = props;
    return (
      <NumberInput
        label={name}
        value={parseInt(field.value)}
        defaultValue={defaultValue}
        disabled={disabled}
        formatter={(value) => `${value} px`}
        max={100}
        {...field}
      />
    );
  };

  const SelectColor = (props) => {
    const { field, name } = props;
    return (
      <>
        <Text size="sm">{name}</Text>
        <Center>
          <ColorInput
            dropdownZIndex={2500}
            value={field.value ?? ""}
            onChange={field.onChange}
          />
        </Center>
      </>
    );
  };

  const fields = [
    {
      key: "obj_nm",
      name: "오브젝트명",
      type: "text",
      options: "validate",
      show: true,
    },
    {
      key: "obj_seq",
      name: "순서",
      type: "number",
      options: "validate",
      defaultValue: objectList?.length + 1,
      min: 1,
      show: true,
    },
    {
      key: "type",
      name: "유형",
      type: "etc",
      component: SelectFieldsType,
      defaultValue: "1",
      show: true,
    },
    {
      key: "cctv_url",
      name: "CCTV URL",
      type: "text",
      disabled: selectedFieldsType === "2" ? false : true,
      options: selectedFieldsType === "2" && "validate",
      show: true,
    },
    {
      key: "left",
      name: "오브젝트 위치(Left)",
      type: "number",
      options: "validate",
      min: 0,
      max: 1570,
      show: true,
    },
    {
      key: "top",
      name: "오브젝트 위치(Top)",
      type: "number",
      options: "validate",
      min: 0,
      max: 770,
      show: true,
    },
    {
      key: "t_yn",
      name: "대체텍스트 여부",
      type: "etc",
      component: RadioAltText,
      defaultValue: "N",
      show: ((selectedFieldsType === "3") || (selectedFieldsType === "4")) ? false : true,    
    },
    {
      key: "t_cont",
      name: "대체텍스트",
      type: "text",
      options: selectedAltTextOption === "Y" && "validate",
      show: ((selectedFieldsType === "3") || (selectedFieldsType === "4")) ? false : true,    
    },
    {
      key: "t_sort",
      name: "텍스트 정렬조건",
      type: "select",
      options: ["Center", "Left", "Right"],
      defaultValue: "Center",
      show: ((selectedFieldsType === "3") || (selectedFieldsType === "4")) ? false : true,   
    },
    {
      key: "t_font_s",
      name: "폰트크기",
      type: "etc",
      component: SelectFontSize,
      defaultValue: 12,
      show: ((selectedFieldsType === "3") || (selectedFieldsType === "4")) ? false : true,  
    },
    {
      key: "t_font_c",
      name: "폰트색상",
      type: "etc",
      component: SelectColor,
      defaultValue: "#000000",
      show: ((selectedFieldsType === "3") || (selectedFieldsType === "4")) ? false : true,   
    },
    {
      key: "t_cont_bg",
      name: "배경색상",
      type: "etc",
      component: SelectColor,
      defaultValue: "",
      show: ((selectedFieldsType === "3") || (selectedFieldsType === "4")) ? false : true,   
    },
    {
      key: "img_url",
      name: "라이브러리",
      type: "etc",
      component: SelectLibrary,
      show: ((selectedFieldsType === "3") || (selectedFieldsType === "4")) ? false : true,   
    },
    {
      key: "view_yn",
      name: "표시여부",
      type: "etc",
      component: RadioAltText,
      defaultValue: "Y",
      show: true,
    },
    {
      key: "sw_cs",
      name: "제어 여부",
      type: "etc",
      component: RadioAltText,
      defaultValue: "N",
      show: ((selectedFieldsType === "3") || (selectedFieldsType === "4")) ? false : true,   
    },
    {
      key: "bsd_id",
      name: "장치",
      type: "etc",
      component: SelectDevice,
      show: true,
    },
    {
      key: "bsd_ctrl_id",
      name: "장치제어",
      type: "etc",
      component: SelectDeviceControl,
      show: selectedControlType === "Y" ? true : false,
    },
    {
      key: "bsd_sttus_id",
      name: "장치상태",
      type: "etc",
      component: SelectDeviceStatus,
      // 제어 채널은의 상태 값은 피드백 채널을 Follow 하여 상태 채널 설정 숨김 - KJ
      show: selectedControlType === "Y" ? false : true,
    },
  ];

  const objectOnSubmit = (e) => {
    const { bsd_id = "", ...rest } = e;

    const newObject = {
      ...rest,
      bsd_id,
      obj_id: objectDefaultValue
        ? objectDefaultValue.obj_id
        : `OBJ-${e.obj_nm}`,
      field_id,
      group_id,
      user_id: "",
      chnnl_ctrl_value: e.bsd_ctrl_id !== null ? e.chnnl_ctrl_value : null,
      chnnl_sttus_value: e.bsd_sttus_id !== null ? e.chnnl_sttus_value : null, 
      width: objectDefaultValue ? objectDefaultValue.width : 30,
      height: objectDefaultValue ? objectDefaultValue.height : 30,
    };

    const newImgyeState = imgyeState && {
      ...imgyeState,
      obj_id: objectDefaultValue
        ? objectDefaultValue.obj_id
        : `OBJ-${e.obj_nm}`,
      imgye_id: objectDefaultValue
        ? imgyeDefaultValue?.imgye_id ?? objectDefaultValue.obj_id
        : `OBJ-${e.obj_nm}`,
    };

    const isDuplicateStatus = objectList.some(
      (obj) =>
        obj.bsd_ctrl_id !== null &&
        obj.bsd_ctrl_id !== undefined &&
        obj.bsd_ctrl_id === newObject.bsd_ctrl_id &&
        obj.bsd_id === newObject.bsd_id &&    
        obj.obj_id !== newObject.obj_id       
    );

    modals.openConfirmModal({
      title: "저장",
      children: <Center>저장 하시겠습니까?</Center>,
    //  centered: true,
      zIndex: 2050,
      labels: { confirm: "저장", cancel: "취소" },
      onConfirm: () => {

        const editModeFlag = false;   

        if (!onConfirmExecutedRef.current) {
          onConfirmExecutedRef.current = true;

          if (objectDefaultValue) {
            if (isDuplicateStatus && !editModeFlag) {    
              alert("이미 해당 제어채널을 가진 오브젝트가 존재합니다.");
            } else {
              setObjectList((prev) =>
                prev
                  ?.filter((obj) => obj.obj_id !== objectDefaultValue.obj_id)
                  ?.concat(newObject)
              );

              if (newImgyeState) {
                setImgyeList((prev) =>
                  prev
                    ?.filter((imgye) => imgye.obj_id !== newImgyeState.obj_id)
                    ?.concat(newImgyeState)
                );
              }
            }
          } else {
            if (isDuplicateStatus && !editModeFlag) {    
              alert("이미 해당 제어채널을 가진 오브젝트가 존재합니다.");
            } else {
              setObjectList((prev) => [...prev, newObject]);
              newImgyeState && setImgyeList((prev) => [...prev, newImgyeState]);
            }
          }
          setTimeout(() => {
            onConfirmExecutedRef.current = false; // 일정 시간 후에 다시 onConfirmExecuted를 false로 변경
          }, 1000); // 여기서 1000은 1초를 의미합니다. 필요에 따라 다른 시간으로 변경 가능
        }
        setSelectedRecords([]);  
        handleObjectAddEditModalClose();
      },
    });
  };

  const thresholdOnSubmit = (e) => {
    const { imgye_range, ...rest } = e;

    const imgyeList = {
      ...rest,
      imgye_st: String(imgye_range[0]),
      imgye_ed: String(imgye_range[1]),
    };
    setImgyeState(imgyeList);
    handleThresholdClose();
  };

  const SubmitButton = () => {
    return (
      <>
        <Center>
          <Flex
            style={{
              width: "100%",
              gap: "10px",
              marginTop: 10,
            }}
          >
            <Button
              variant="outline"
              disabled={selectedFieldsType === "4"}
              onClick={() => handleThresholdOpen(objectDefaultValue?.obj_id)}
            >
              임계치 생성/수정
            </Button>
            <Button type="submit">확인</Button>
          </Flex>
        </Center>
      </>
    );
  };

  // 불필요한 리렌더링 방지
  const MemoizedObjectItem = React.memo(ObjectItem);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <Flex gap={15} style={{ width: "1600px" }}>
        <Button
          onClick={handleObjectManagementOpen}
          style={{
            margin: "10px 0px",
          }}
          disabled={Object.keys(defaultObjectState).length === 0}
        >
          오브젝트 관리
        </Button>
        <Button
          onClick={insertObject}
          style={{
            margin: "10px 0px",
          }}
          type="submit"
          disabled={Object.keys(defaultObjectState).length === 0}
        >
          오브젝트 저장
        </Button>
        <Button
          onClick={copyDeviceObjectOpen}
          style={{
            margin: "10px 0px",
          }}
          disabled={Object.keys(defaultObjectState).length === 0}
        >
          장치 오브젝트 복사
        </Button>
      </Flex>
      <DraggableArea objectList={objectList} setObjectList={setObjectList}>
        {objectList?.map((object) => (
          <MemoizedObjectItem
            id={object.obj_id}
            object={object}
            imgyeList={imgyeList}
            objectOnClick={handleObjectAddEditModalOpen}
          />
        ))}
      </DraggableArea>
      <Modal
        opened={copyDeviceObjectOpened}
        onClose={copyDeviceObjectClose}
        title="장치 오브젝트 복사"
      //  centered
        size="xl"
        zIndex={2000}
      >
        <CopyDeviceObject
          group_id={group_id}
          field_id={field_id}
          deviceList={deviceList}
          fieldList={fieldList}
        />
      </Modal>

      <Modal
        opened={objectManagementOpened}
        onClose={handleObjectManagementClose}
        title="오브젝트 관리"
      //  centered
        size="xl"
        zIndex={2000}
      >
        <ObjectManagement
          handleObjectAddEditModalOpen={handleObjectAddEditModalOpen}
          handleThresholdOpen={handleThresholdOpen}
          objectList={objectList}
          setObjectList={setObjectList}
          setDeleteObjectList={setDeleteObjectList}
          imgyeList={imgyeList}
          setImgyeList={setImgyeList}
          selectedRecords={selectedRecords}
          setSelectedRecords={setSelectedRecords}
          selectedImgye={selectedImgye}
          setSelectedImgye={setSelectedImgye}
          setDeleteImgyeList={setDeleteImgyeList}   
        />
      </Modal>
      <Modal
        opened={objectAddEditModalOpened}
        onClose={handleObjectAddEditModalClose}
        title="오브젝트 생성/수정"
     //   centered
        size="xl"
        zIndex={2010}
      >
        <ObjectAddEditForm
          fields={fields}
          onSubmit={objectOnSubmit}
          submitButton={<SubmitButton />}
          defaultValues={objectDefaultValue}
        />
      </Modal>
      <Modal
        opened={handleThresholdOpened}
        onClose={handleThresholdClose}
        title="임계치 생성/수정"
     //   centered
        size="xl"
        zIndex={2020}
      >
        <ThresholdForm
          libraryList={libraryList}
          thresholdOnSubmit={thresholdOnSubmit}
          handleThresholdClose={handleThresholdClose}
          defaultValue={imgyeDefaultValue}
          imgyeState={imgyeState}
        />
      </Modal>
    </div>
  );
}

export default SiteEditAddForm;
